module.exports = __webpack_public_path__ + "static/PR-3581b5535df734ed661136b104f3af50.jpg";